
import { Button } from '@unified-checkout/design-system';
import type { IMultiSectionCardProps } from '@app/dashboard/types/innerLayout/multi-section-card';
import styles from './multi-section-card.module.scss';

export const MultiSectionCard = ({
  title,
  subtitle,
  icon,
  btnProps,
  color = 'gray',
}: IMultiSectionCardProps) => {
  return (
    <div className={styles['multi-section-card']}>
      <div
        className={styles['multi-section-card__content']}
        data-multi-section-card-bg-color={color}>
        {
          icon &&
          <div className={styles['multi-section-card__content__icon-wrapper']}>
            {typeof icon === 'string' ?
              <img src={icon} alt="icon" />
              :
              icon
            }
          </div>
        }
        <div className={styles['multi-section-card__content__account-info']}>
          <div className={styles['multi-section-card__content__account-info__title']}>
            {title}
          </div>
          <div className={styles['multi-section-card__content__account-info__subtitle']}>
            {subtitle}
          </div>
        </div>
      </div>
      {
        btnProps?.map((btn, index) =>
          <Button key={index} {...btn} />
        )
      }
    </div>
  );
}
